/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetUserIdTournamentRegistrationsQueryResponse,
  GetUserIdTournamentRegistrationsPathParams,
  GetUserIdTournamentRegistrations500,
} from "../types/GetUserIdTournamentRegistrations.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUserIdTournamentRegistrationsQueryKey = (
  id: GetUserIdTournamentRegistrationsPathParams["id"] | undefined,
) =>
  [{ url: "/user/:id/tournament-registrations", params: { id: id } }] as const;

export type GetUserIdTournamentRegistrationsQueryKey = ReturnType<
  typeof getUserIdTournamentRegistrationsQueryKey
>;

/**
 * {@link /user/:id/tournament-registrations}
 */
export async function getUserIdTournamentRegistrations(
  id: GetUserIdTournamentRegistrationsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetUserIdTournamentRegistrationsQueryResponse,
    ResponseErrorConfig<GetUserIdTournamentRegistrations500>,
    unknown
  >({
    method: "GET",
    url: `/user/${id}/tournament-registrations`,
    ...requestConfig,
  });
  return res;
}

export function getUserIdTournamentRegistrationsQueryOptions(
  id: GetUserIdTournamentRegistrationsPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getUserIdTournamentRegistrationsQueryKey(id);
  return queryOptions<
    ResponseConfig<GetUserIdTournamentRegistrationsQueryResponse>,
    ResponseErrorConfig<GetUserIdTournamentRegistrations500>,
    ResponseConfig<GetUserIdTournamentRegistrationsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getUserIdTournamentRegistrations(id!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * {@link /user/:id/tournament-registrations}
 */
export function useGetUserIdTournamentRegistrations<
  TData = ResponseConfig<GetUserIdTournamentRegistrationsQueryResponse>,
  TQueryData = ResponseConfig<GetUserIdTournamentRegistrationsQueryResponse>,
  TQueryKey extends QueryKey = GetUserIdTournamentRegistrationsQueryKey,
>(
  id: GetUserIdTournamentRegistrationsPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetUserIdTournamentRegistrationsQueryResponse>,
        ResponseErrorConfig<GetUserIdTournamentRegistrations500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getUserIdTournamentRegistrationsQueryKey(id);

  const query = useQuery(
    {
      ...getUserIdTournamentRegistrationsQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetUserIdTournamentRegistrations500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
